export const rowsPerPageOptions = [10, 20, 50, 100];
export const defaultRowsPerPage = 20;
